export default __webpack_public_path__ + "static/media/NoteApp_content1.49bc1f7f.jpg";